import { Alert } from "antd";
import { Button } from "components/Button/Button";
import { CancelButton } from "components/Form/components/CancelButton/CancelButton";
import { Form } from "components/Form/components/Form/Form";
import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { IconCollection } from "components/Icon/IconCollection";
import { UncommittedResourceListField } from "containers/Resources/screens/ResourcesSingle/components/GitAction/commitActions/formComponents/UncommittedResourceListField";
import { UncommittedData } from "containers/Resources/screens/ResourcesSingle/components/GitAction/commitActions/utils";
import { Field } from "react-final-form";
import styles from "../../GitAction.module.scss";

interface BulkResetFormProps extends FormComponentProps {
    uncommittedRecordList: UncommittedData[];
    closeModal: () => void;
    handleSubmit: (data) => Promise<any>;
    submitSucceeded: boolean;
    values: any;
}

export const BulkResetForm = ({
    uncommittedRecordList,
    closeModal,
    handleSubmit,
    submitSucceeded,
    values,
}: BulkResetFormProps) => {
    return (
        <Form onSubmit={handleSubmit}>
            <Form.Row>
                <Field name="records" id="records" fieldProps={{}} fieldAttr={{}}>
                    {(props: FormComponentProps) => (
                        <UncommittedResourceListField
                            uncommittedRecordList={uncommittedRecordList}
                            {...props}
                        />
                    )}
                </Field>
            </Form.Row>
            <div className={styles.resetAlert}>
                <Alert
                    message="Warning: resetting to status in git will overwrite existing changes!"
                    type="warning"
                    showIcon
                />
            </div>
            <Form.Row>
                <CancelButton onClick={() => closeModal()} />
                <Button
                    submit
                    loading={submitSucceeded}
                    variation="primary"
                    label="Bulk reset"
                    icon={IconCollection.undo}
                    disabled={values?.records?.length === 0}
                />
            </Form.Row>
        </Form>
    );
};
